export { default } from './withToggleMatureContent';
